// api.js — thin fetch wrapper over the FastAPI backend.
// Ported from server/static/api.js: same surface, now a real ES module
// instead of a window.API global.

export const api = {
  async getStudyNext() {
    const r = await fetch("/api/study/next");
    return r.json();
  },
  async getState() {
    const r = await fetch("/api/dashboard");
    return r.json();
  },
  async getGraph() {
    const r = await fetch("/api/graph");
    return r.json();
  },
  async getDashboard() {
    const r = await fetch("/api/dashboard");
    return r.json();
  },
  async getCourses() {
    const r = await fetch("/api/courses");
    return r.json();
  },
  async getPlan(courseIds = []) {
    const qs = courseIds.length ? `?courses=${encodeURIComponent(courseIds.join(","))}` : "";
    const r = await fetch(`/api/plan${qs}`);
    return r.json();
  },
  async getTemporal(days = 30, forecastDays = 14) {
    const r = await fetch(`/api/temporal?days=${days}&forecast_days=${forecastDays}`);
    return r.json();
  },
  async postRecord({ item_id, score, duration_s = null, feedback = null }) {
    const r = await fetch("/api/record", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ item_id, score, duration_s, feedback }),
    });
    return r.json();
  },
  async postReflect({ item_id, auto_score, self_rating, probe_answer = null }) {
    const r = await fetch("/api/reflect", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ item_id, auto_score, self_rating, probe_answer }),
    });
    return r.json();
  },
  async postFirstWinCompose({ session_id, frame_ids = null }) {
    const r = await fetch("/api/firstwin/compose", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id, frame_ids }),
    });
    return r.json();
  },
  async postIngestUpload(file, { context = "", course = "" } = {}) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("context", context);
    fd.append("course", course);
    const r = await fetch("/api/ingest/upload", { method: "POST", body: fd });
    if (!r.ok) throw new Error(`ingest failed: ${r.status}`);
    return r.json();
  },
  async getIngestStatus(courseId) {
    if (!courseId) return { state: "unknown" };
    const r = await fetch(`/api/ingest/status/${encodeURIComponent(courseId)}`);
    if (!r.ok) return { state: "unknown" };
    return r.json();
  },
  async postIngestText(content, { course = "", source_name = "" } = {}) {
    const r = await fetch("/api/ingest", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ content, course, source_name }),
    });
    if (!r.ok) throw new Error(`ingest failed: ${r.status}`);
    return r.json();
  },
};

export default api;
